export default {
  labelText: '{{name}}',
};
